
import {useState} from 'react'
import {FiUpload} from 'react-icons/fi'
import {IoClose} from 'react-icons/io5'
import { base_url, department } from '../constant/Appconstants'
import ErrorComponent from '../constant/ErrorComponent'
import axios from 'axios'
import {message} from 'antd'
import Typist from 'react-typist';
import { useNavigate } from 'react-router-dom'

function Carrer() {

  const navigator = useNavigate();
  const [data,setdata] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
  const [error,seterror] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})

  function handleChange(e){
    setdata({...data,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  } 

  async function submitForm(){
    if(!data?.name){
      seterror({...error,name:'This Field is required *'})
    }else if(!data?.mobile && data.mobile.length < 10){
      seterror({...error,mobile:'This Field is required *'})
    }else if(!data?.email){
      seterror({...error,email:'This Field is required *'})
    }else if(!data?.experience){
      seterror({...error,experience:'This Field is required *'})
    }else if(!data?.file){
      seterror({...error,file:'This Field is required *'})
    }else{

      const fd = new FormData()
      fd.append('name',data?.name)
      fd.append('mobile',data?.mobile)
      fd.append('email',data?.email)
      fd.append('experience',data?.experience)
      fd.append('previous_company',data?.previous_company)
      fd.append('query',data?.query)
      fd.append('file',data?.file)
      fd.append('department_website',department)

      const headers = {headers:{
        'Content-Type':'multipart/form-data'
      }}
      
      await axios.post(`${base_url}applicant/create`,fd,headers)
      .then((res)=>{
        if(res?.status === 201){
          message.success('Form Submitted Successfully')
          setdata({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
          seterror({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
        }
      }).catch((err)=>{      
      }) 
    }
  }

  return (
    <div className="w-full h-full  bg-white">
        <div className='h-[140px]  relative md:min-h-[240px] 2xl:min-h-[500px] bg-cover md:bg-cover bg-no-repeat w-full bg-joinus_bg'>
            <div className='border-l w-[75%] md:w-[35%] border-l-4  border-l-[#4190ac] ml-[2%] pl-[1.5%] absolute top-[15%]'>
                {/* <Typist avgTypingDelay={15} stdTypingDelay={15}> */}
                <h6 className='text-[19px] 2xl:text-[22px] font_thicker md:text-[21px] text-[#fff] font-[800]  '>Join Us</h6>
                <h6 className='text-[13px] 2xl:text-[16px] font_normal md:text-[14px] text-[#fff]'>If you want join our martian army of Fidelitus FMS Services. Please use the form below to Join us.</h6>
                {/* </Typist> */}
            </div>
        </div>

      {/* <div className='h-[250px] w-screen overflow-hidden relative md:h-[400px] grid place-items-center  bg-[#f7f3ef]  '>
      
       <div >
        <h1 className='text-center text-[40px]'>Contact us</h1>

        <h6 className='text-center tracking-wider text-black-400 text-[14px]'> <span className='cursor-pointer'>Home</span> / Contact us</h6>
        <h6 className='text-center tracking-wider text-black-400 text-[12px]'>24/7 We are ready to assist you!</h6>
        </div>

        <img src={GLobe} className="absolute -right-[35vw]  animate-rotate-full   h-[250px]  md:h-[400px] object-contain " />
        <img src={User} className="absolute -right-[28%] md:right-0 top-10   h-[250px]  md:h-[400px] object-contain " />

      </div> */}

        <div className=''>
        <div className='w-[80vw] mx-auto py-10'>
       

        <div>

           
           <div className='flex-row-reverse md:flex-row md:flex '>
              <div data-aos="fade-up" className='md:mt-10 md:w-[48%]'>
                  <h6 className='ml-1 text-[26px] 2xl:text-[29px] font_thicker w-[100%] md:w-[70%]'>Looking to Join our Family as an FMS Employee.</h6>

                  <h6 className=' mt-5 text-gray-600 w-[100%]  mx-auto text-[14px]'>Contact us and you&apos;ll receive a call as soon as you get shortlisted </h6>
                  <div className='mt-5 w-full'>
                <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Name</h6>
                <input type='text' name="name" value={data?.name} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
              </div>

              <ErrorComponent error={error?.name} />

              <div className='mt-2 w-full'>
                <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Mobile</h6>
                <input type='text' name="mobile" value={data?.mobile} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
              </div>
              <ErrorComponent error={error?.mobile} />


              <div className='mt-2 w-full'>
                <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Email</h6>
                <input type='text' name="email" value={data?.email} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
              </div>
              <ErrorComponent error={error?.email} />


              <div className='mt-2 w-full'>
                <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Experience</h6>
                <input min={0} name="experience" value={data?.experience} onChange={handleChange} type='number' className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
              </div>

              <ErrorComponent error={error?.experience} />



              <div className='mt-2 w-full'>
                <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Previous Company</h6>
                <input type='text'  name="previous_company" value={data?.previous_company} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 2xl:p-2 text-[13px]' />
              </div>


              <div className='mt-2 w-full'>
                <h6 className='mb-1 text-[13px] 2xl:text-[16px]'>Upload Resume</h6>
                {data?.file === '' ? 
                <form onClick={()=>document.querySelector('.input-field').click()} className={`p-4 flex flex-col items-center justify-center cursor-pointer rounded   border-dashed border`}>
                  <FiUpload size={24} />
                  <span className='font-bold font_normal text-[10px] 2xl:text-[13px] mt-1 text-center'>Click To Upload Photo</span>
                  <span className='font-bold font_normal text-[7px] 2xl:text-[10px] mt-0 text-center'>Supported Type JPEG,PNG,SVG,WEBP</span>
                  <input type='file' onChange={({target:{files}})=>{
                    files[0] && setdata({...data,file:files[0]});seterror({...error,file:''})
                  }} accept="image/*" className='input-field' hidden />
               </form> 
                :
                <div className='flex border relative p-2'>
                    <h6 className='text-[13px] 2xl:text-[16px] font_normal truncate w-[95%] pl-2'>{data?.file?.name}</h6>
                    <IoClose className='absolute  right-2' onClick={()=>{setdata({...data,file:''});seterror({...error,file:''})}}/>
                </div>  
                }

              </div>

              <ErrorComponent error={error?.file} />


              <div className='mt-2 w-full'>
                <h6 className='mb-1 font_normal text-[13px] 2xl:text-[16px]'>Query</h6>
                <textarea name="query" value={data?.query} onChange={handleChange} type='text' className='border w-full focus:ring-0 focus:outline-none p-1' />
              </div>


                  <button onClick={submitForm} className='text-[12px] 2xl:text-[15px] flex font_normal mt-2 items-end justify-end bg-black text-white p-2'>
                    SUBMIT
                  </button>

              </div>

              <div data-aos="fade-up" className='md:ml-[4%] md:w-[48%] mt-10'>
                <div className='w-[100%]'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15555.201402509898!2d77.5725512!3d12.9205498!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14293cbbedf9%3A0x4f12794ce5a209a4!2sFidelitus%20Corp!5e0!3m2!1sen!2sin!4v1691664501989!5m2!1sen!2sin" className='w-full' height="400"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
           </div>


          

        </div>
        


       










      
        </div>
        </div>

      

      <h1 data-aos="fade_up" className=' text-center font_thicker text-[17px] mt-10'>View Our  <span className='text-[#4190ac] font_medium'>Other</span>  Branches?</h1>


      <div className='grid grid-cols-3 px-10 place-self-center place-content-center md:flex items-center  justify-center mt-10 mb-20'>
        <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>BANGALORE</span>
        <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>HYDERABAD</span>
        <span data-aos="fade_right" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>CHENNAI</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>MUMBAI</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>DELHI</span>
        <span data-aos="fade_up" data-aos-delay="400" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>AHMEDABAD</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black border-l md:border-l-0'>KOLKATA</span>
        <span data-aos="fade_left" data-aos-delay="300"  className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black'>PUNE</span>
        <span data-aos="fade_left" data-aos-delay="300" className='px-2 text-[13px] text-center mb-4 md:mb-0 text-black cursor-pointer border-r border-black md:border-none'>KOCHI</span>
        
      </div>


        {/* <div className='bg-[#f7f3ef] px-[10vw] py-20 md:flex justify-between'>
            <h6 className='font_thicker font-[500] text-[30px] md:w-[70%]'>We provide all kinds of IT & Non IT Candidates that vow your organization <span className='text-[#4190ac]'>success</span></h6>


            <button className='mt-10 md:mt-0'>
              
              <Link href={`tel:${mobile}`} target='_blank'>
              <div className='flex items-center bg-[#000] text-white rounded p-3 transition duration-300 ease-in hover:-translate-y-1 '>
                <BsChatLeftDots />
                <h6 className='ml-3'>Let&apos;s Talk</h6>
              </div>
              </Link>
            </button>


        </div> */}
    </div>
  )
}

export default Carrer